import { render, staticRenderFns } from "./WorkDetailModule.vue?vue&type=template&id=a786b900&scoped=true&"
import script from "./WorkDetailModule.vue?vue&type=script&lang=js&"
export * from "./WorkDetailModule.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetailModule.vue?vue&type=style&index=0&id=a786b900&prod&scoped=true&lang=scss&"
import style1 from "./WorkDetailModule.vue?vue&type=style&index=1&id=a786b900&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a786b900",
  null
  
)

export default component.exports